/**
 * No-login email preference center (backend `/api/v1/marketing/preferences`).
 * The token from the email footer is the only credential. It is sent only in a
 * POST body, never in a request URL, so it stays out of access logs.
 */

import api from './api';

export const CATEGORY_COPY = {
  marketing: {
    title: 'Offers and news',
    description: 'Price changes, feature news, and invitations like feedback calls.',
  },
  account: {
    title: 'Account and security',
    description: 'Sign-in codes, billing receipts, family invites, and trial notices. We always send these.',
  },
};

export const NOTE_COPY = {
  delivery_blocked: 'Email to this address is paused because a message bounced or was reported. Contact support@budgit.app to turn it back on.',
  no_account: 'There is no active Budgit account for this address, so offers stay off.',
};

export const readPreferences = async (token) => {
  const response = await api.post('/marketing/preferences', { token });
  return response.data;
};

export const saveMarketing = async (token, marketing) => {
  const response = await api.post('/marketing/preferences', { token, marketing });
  return response.data;
};

export const errorCode = (error) => error?.response?.data?.code || null;
